export var ShareProvider;
(function (ShareProvider) {
    ShareProvider[ShareProvider["FACEBOOK"] = 0] = "FACEBOOK";
    ShareProvider[ShareProvider["TWITTER"] = 1] = "TWITTER";
    ShareProvider[ShareProvider["REDDIT"] = 2] = "REDDIT";
    ShareProvider[ShareProvider["STUMBLEUPON"] = 3] = "STUMBLEUPON";
    ShareProvider[ShareProvider["LINKEDIN"] = 4] = "LINKEDIN";
    ShareProvider[ShareProvider["GOOGLEPLUS"] = 5] = "GOOGLEPLUS";
    ShareProvider[ShareProvider["TUMBLR"] = 6] = "TUMBLR";
    ShareProvider[ShareProvider["PINTEREST"] = 7] = "PINTEREST";
    ShareProvider[ShareProvider["WHATSAPP"] = 8] = "WHATSAPP";
})(ShareProvider || (ShareProvider = {}));
//# sourceMappingURL=share-provider.enum.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-sharebuttons/helpers/share-provider.enum.js
// module id = ./node_modules/ngx-sharebuttons/helpers/share-provider.enum.js
// module chunks = vendor